import { InjectionToken, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { RSA_CRYPTO_PROVIDER } from '@shared/utils/crypto';
import { IAuthRepository } from './domain/repositories/auth.repository';
import { ITokenStorageRepository } from './domain/repositories/token-storage.repository';
import { IAuthProvider } from './domain/providers/auth.provider';
import { ApiAuthRepository } from './infra/repositories/api-auth.repository';
import { SessionTokenStorageRepository } from './infra/repositories/session-token-storage.repository';
import { MsalAuthProvider } from './infra/providers/msal-auth.provider';

export const TOKEN_STORAGE_REPOSITORY =
  new InjectionToken<ITokenStorageRepository>('TOKEN_STORAGE_REPOSITORY', {
    providedIn: 'root',
    factory: () => new SessionTokenStorageRepository(),
  });

export const AUTH_API_REPOSITORY = new InjectionToken<IAuthRepository>(
  'AUTH_API_REPOSITORY',
  {
    providedIn: 'root',
    factory: () =>
      new ApiAuthRepository(inject(HttpClient), inject(RSA_CRYPTO_PROVIDER)),
  },
);

export const AUTH_PROVIDER = new InjectionToken<IAuthProvider>(
  'AUTH_PROVIDER',
  {
    providedIn: 'root',
    factory: () => new MsalAuthProvider(inject(MsalService)),
  },
);
